var map = {
	"./007-microphone-1.png": 1331,
	"./010-home.png": 65449,
	"./013-document-1.png": 94678,
	"./014-document.png": 34690,
	"./015-color-palette.png": 47228,
	"./017-video-camera.png": 85817,
	"./024-like.svg": 28038,
	"./1.svg": 83169,
	"./155-credit-card.svg": 58534,
	"./2.svg": 214,
	"./3.svg": 44122,
	"./4.svg": 27103,
	"./New Customer.svg": 68114,
	"./NotOpen.svg": 18012,
	"./Opened.svg": 13732,
	"./Profit.svg": 96755,
	"./SalesRevenue.svg": 18079,
	"./Sent.svg": 84477,
	"./Slack.svg": 7790,
	"./address.svg": 20633,
	"./adobe.svg": 55253,
	"./arrow-left.svg": 47156,
	"./arrow-right.svg": 84908,
	"./book.svg": 45183,
	"./camera.svg": 18906,
	"./chat.svg": 5971,
	"./clipboard.svg": 78178,
	"./cloud.svg": 3288,
	"./columns.svg": 90718,
	"./documentation.svg": 92815,
	"./file.svg": 26439,
	"./flat.svg": 13653,
	"./headphone.svg": 7924,
	"./iconfinder_trello_2317760.svg": 10180,
	"./idea.svg": 1926,
	"./image.png": 38420,
	"./image.svg": 96324,
	"./label.png": 36887,
	"./layers.svg": 91300,
	"./left.svg": 71714,
	"./logo2.svg": 75709,
	"./logo3.svg": 44142,
	"./logo4.svg": 41251,
	"./logo5.svg": 57586,
	"./logo6.svg": 81832,
	"./logoIn.svg": 75569,
	"./paint.svg": 32179,
	"./protection.svg": 77280,
	"./quote.png": 220,
	"./repeat.svg": 6294,
	"./right.svg": 39961,
	"./strategy.svg": 91096,
	"./theme.svg": 44530,
	"./user.svg": 55521,
	"./water-fall.svg": 54725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34542;